import localPersist from './_localPersist'

export default localPersist({
  key: 'form',
  module: 'form',
  filter: ['setPhones', 'clearPhones']
})
